"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonSlideTaskTermListening = void 0;
var enums_1 = require("./enums");
/** Слайд меморайзера "Прослушивание" */
var LessonSlideTaskTermListening = /** @class */function () {
  function LessonSlideTaskTermListening() {
    this.type = enums_1.LessonSlideContentTypeEnum.TaskTermListening;
  }
  return LessonSlideTaskTermListening;
}();
exports.LessonSlideTaskTermListening = LessonSlideTaskTermListening;
